import { render, staticRenderFns } from "./ModalUi.vue?vue&type=template&id=3d3394b4&"
import script from "./ModalUi.vue?vue&type=script&lang=js&"
export * from "./ModalUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports